(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post-sidebar"]) return;
  try {
    
  (function() {
    var sidebar = document.querySelector('.article-sidebar');
    if (!sidebar) return;

    /* Sticky-follow applies ONLY to the two-column desktop layout.
       Below 990px the sidebar is stacked under the article (see the
       max-width: 989px block in the stylesheet above) and must stay in
       normal flow. Inline styles set here would otherwise override the
       CSS `position: static`, leaving a sticky element with a large
       negative `top` that judders while scrolling on phones. */
    var DESKTOP = 990;
    var HEADER = 100;
    var PAD = 20;
    var lastY = window.scrollY;
    var state = 'TOP';
    var ticking = false;

    function isDesktop() {
      return window.innerWidth >= DESKTOP;
    }

    function reset() {
      sidebar.style.position = '';
      sidebar.style.top = '';
      state = 'TOP';
    }

    function stickyTop() {
      sidebar.style.position = 'sticky';
      sidebar.style.top = HEADER + 'px';
      state = 'TOP';
    }

    function stickyBottom() {
      sidebar.style.position = 'sticky';
      sidebar.style.top = -(sidebar.offsetHeight - window.innerHeight + PAD) + 'px';
      state = 'BOTTOM';
    }

    function freeze() {
      var rect = sidebar.getBoundingClientRect();
      var pRect = sidebar.parentElement.getBoundingClientRect();
      sidebar.style.position = 'relative';
      sidebar.style.top = (rect.top - pRect.top) + 'px';
      state = 'FREE';
    }

    function onScroll() {
      ticking = false;

      if (!isDesktop()) {
        if (sidebar.style.position) reset();
        return;
      }

      var y = window.scrollY;
      var delta = y - lastY;
      lastY = y;
      if (delta === 0) return;

      var h = sidebar.offsetHeight;
      var vh = window.innerHeight;

      if (h <= vh - HEADER - PAD) { stickyTop(); return; }

      var down = delta > 0;
      var rect = sidebar.getBoundingClientRect();

      if (state === 'TOP' && down) {
        freeze();
      } else if (state === 'BOTTOM' && !down) {
        freeze();
      } else if (state === 'FREE') {
        if (down && rect.bottom <= vh - PAD) {
          stickyBottom();
        } else if (!down && rect.top >= HEADER) {
          stickyTop();
        }
      }
    }

    if (isDesktop()) stickyTop();

    window.addEventListener('scroll', function() {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });

    window.addEventListener('resize', function() {
      if (!isDesktop()) { reset(); return; }
      /* crossing up from mobile: sticky was never initialised */
      if (!sidebar.style.position) { stickyTop(); return; }
      if (state === 'BOTTOM') stickyBottom();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
